import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { getEventDateString } from '../../../utils/formatting';

import styles from './findEventsCard.scss';

class FindEventsCard extends Component {
    constructor(props) {
        super(props);
        this.navigateToEvent = this.navigateToEvent.bind(this);
    }

    navigateToEvent(eventUrl) {
        // eslint-disable-next-line
        location.href = eventUrl;
    }

    render() {
        const { showHeader, 'data-testid': dataTestId } = this.props;
        const { name, locationString, eventSchedule, organizer, url } = this.props.event;

        const Header = () => {
            return (
                <div className={`row ${styles.header}`}>
                    <div className={`col-4`}>
                        <div className={`${styles.text}`} data-testid={dataTestId && `${dataTestId}.header.name-label`}>
                            Name
                        </div>
                    </div>
                    <div className={`col-3`}>
                        <div className={`${styles.text}`} data-testid={dataTestId && `${dataTestId}.header.dates-label`}>
                            Dates
                        </div>
                    </div>
                    <div className={`col-3`}>
                        <div className={`${styles.text}`} data-testid={dataTestId && `${dataTestId}.header.location-label`}>
                            Location
                        </div>
                    </div>
                    <div className={`col-2`}>
                        <div className={`${styles.text}`} data-testid={dataTestId && `${dataTestId}.header.organizer-label`}>
                            Organizer
                        </div>
                    </div>
                </div>
            );
        };

        return (
            <div className={`${styles.eventsCard}`}>
                {showHeader && (
                    <Header />
                )}
                <div className={`${styles.listView} ${this.props.forceCardView ? 'd-none' : 'd-block'}`}>
                    <div className={`row`}>
                        <div className={`col-4`}>
                            {
                                (url.indexOf('http://') === 0 || url.indexOf('https://') === 0)
                                    ? <a className={`${styles.text} ${styles.highlight}`} href={url} rel="noopener noreferrer" target="_blank" data-testid={dataTestId && `${dataTestId}.name-link`}>{name}</a>
                                    : <Link className={`${styles.text} ${styles.highlight}`} to={url} data-testid={dataTestId && `${dataTestId}.name-link`}>{name}</Link>
                            }
                        </div>
                        <div className={`col-3`}>
                            <div className={`${styles.text}`} data-testid={dataTestId && `${dataTestId}.dates`}>
                                {getEventDateString(eventSchedule)}
                            </div>
                        </div>
                        <div className={`col-3`}>
                            <div className={`${styles.text}`} data-testid={dataTestId && `${dataTestId}.location`}>
                                {locationString}
                            </div>
                        </div>
                        <div className={`col-2`}>
                            <div className={`${styles.text}`} data-testid={dataTestId && `${dataTestId}.organizer`}>
                                {organizer}
                            </div>
                        </div>
                    </div>
                </div>
                <div className={`${styles.cardView} ${this.props.forceCardView ? 'd-block' : 'd-block d-md-none'}`} />
            </div>
        );
    }
}

FindEventsCard.defaultProps = {
    'data-testid': null,
};

export default FindEventsCard;
